import { useEffect, useState } from 'react'
import { Calendar, DateRange } from '@flatfile/baseline'

export function DashboardDatePickerWidget({
  daysAgo30,
  now,
  setStartDateValue,
}: {
  daysAgo30: Date
  now: Date
  setStartDateValue: (p: [Date, Date]) => void
}) {
  const [date, setDate] = useState<DateRange | undefined>({
    from: daysAgo30,
    to: now,
  })

  useEffect(() => {
    if (date?.from && date?.to) {
      setStartDateValue([date.from, date.to])
    }
  }, [date, setStartDateValue])

  return (
    <div className='p-1'>
      <Calendar
        initialFocus
        mode='range'
        defaultMonth={date?.from}
        selected={date}
        onSelect={setDate}
        numberOfMonths={2}
        disabled={{ after: new Date() }}
      />
    </div>
  )
}
